import { useReceipt } from 'containers/BusinessInsightModule/BIDigitalDocument/hooks/useReceipt';
import { useRefund } from 'containers/BusinessInsightModule/BIDigitalDocument/hooks/useRefund';
import React, { useEffect } from 'react'

const CustomDocumentGenerator = ({
  item,
  HotelDetails,
  BIUsersLisiting,
  GetCurrentGovTax,
  GetServiceChargeTax,
  folioInfo,
  NonGuestBilling = [],
  onTemplatesReady
}) => {
  const paymentEntry = NonGuestBilling?.find(
    (el: any) => el.ID === item?.PaymentReferenceID
  )

  const PaymentDetails = [paymentEntry, item].filter(Boolean)
  
  const hookProps = {
    Type: "PaymentFolio",
    stateInfo: item,
    HotelDetails,
    BIUsersLisiting,
    GetCurrentGovTax,
    GetServiceChargeTax,
    GetTaxScheme: folioInfo?.TaxSchemeLedger || [],
  }

  const refundHook = useRefund({
    ...hookProps,
    stateInfo: { 
      ...item, 
      ID: item?.ID,
      PaymentClass: item?.PaymentClass, 
      SelectedItem: item,
      PaymentDetails 
    }
  }) as any

  const receiptHook = useReceipt(hookProps) as any

  const DocumentTemplate = item?.PaymentClass === 'Refund' 
    ? refundHook?.RefundTemplate 
    : receiptHook?.ReceiptTemplate

  useEffect(() => {
    if (!onTemplatesReady || !DocumentTemplate) return
    
    const documentType = item?.PaymentClass === "Refund" ? "HTRF" : "RCPT"

    onTemplatesReady({
      receiptNo: item?.ReceiptNo,
      documentType,
      template: DocumentTemplate,
    })
  }, [DocumentTemplate])

  return (
    <>
      <div>
        <div 
          style={{ fontSize: 12, padding: 5 }}
          className="m-t-15"
          dangerouslySetInnerHTML={{ __html: DocumentTemplate }} 
        />
      </div>
    </>
  )
}

export default CustomDocumentGenerator